// src/components/BottomNav.jsx
import React from "react";
import { FaHome, FaChessRook, FaPlus, FaThLarge, FaUser } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import "./BottomNav.css";

const BottomNav = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  // Kingdom stays highlighted on /kingdom and on /kingdom/:userId
  const isKingdomActive = location.pathname.startsWith("/kingdom");

  return (
    <div className="bottom-nav">
      <Link
        to="/HomeScreen"
        aria-label="Home"
        className={`nav-item ${isActive("/HomeScreen") ? "active" : ""}`}
      >
        <FaHome />
      </Link>
      <Link
        to="/kingdom"
        aria-label="Kingdom"
        className={`nav-item ${isKingdomActive ? "active" : ""}`}
      >
        <FaChessRook />
      </Link>
      <Link
        to="/add"
        aria-label="Post an idea"
        className={`nav-item add-icon ${isActive("/add") ? "active" : ""}`}
      >
        <FaPlus />
      </Link>
      <Link
        to="/grid"
        aria-label="Grid"
        className={`nav-item ${isActive("/grid") ? "active" : ""}`}
      >
        <FaThLarge />
      </Link>
      <Link
        to="/profile"
        aria-label="Profile"
        className={`nav-item ${isActive("/profile") ? "active" : ""}`}
      >
        <FaUser />
      </Link>
    </div>
  );
};

export default BottomNav;